import {useAuth, useUser} from "@clerk/nextjs";
import {omniStorage, setOmniStorageItems, storage} from "~/helpers";
import {authenticationLoggedOutFinished, authenticationSuccess} from "~/store/actions";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {api} from "~/utils/axiosInstances";
import {analytics} from "~/router/events";
import {setUserProperties} from "firebase/analytics";
import {setDimension} from "~/helpers/google-analytics";
import {router} from "next/router";
import {webrtc} from "~/providers/MfdProvider";
import Loading from "~/components/Loading";

export const AuthIntermediator = ({children, ...props}) => {
    const {user, isLoaded } = useUser()
    const {signOut, getToken, isSignedIn} = useAuth()
    const dispatch = useDispatch()
    const [finishedAuthentication, setAuthentication] = useState(false)
    const loggedOut = useSelector((state) => state.authenticationReducer.loggedOut);
    const source = useSelector((state) => state.userSource.source)

    useEffect(() => {

        if (!isLoaded) {
            return
        }
        const setAuthdetails = async () => {
            const storedToken = storage.getItem('token')
            if (!storedToken) {
                await getToken()
                const token = user.publicMetadata.authToken
                storage.setItem('token', token)
                /* eslint-disable */
                if (window?.Android) {
                    window.Android.consumeToken(token, userDetails.email)
                }
                if (window?.Amazon) {
                    window.Amazon.consumeToken(token, userDetails.email)
                }
            }

            try {
                const response = await api.get('users/@me')
                const {data: userData} = response
                let hosts = []
                if (userData.host) {
                    hosts = [userData.host]
                }

                const meUser = {
                    ...userData,
                    hosts
                }

                setOmniStorageItems(meUser, hosts)
                dispatch(authenticationSuccess({user: meUser, token: user.publicMetadata.authToken}))
                setAuthentication(true)
            } catch (error) {
                throw error
            }
        }

        void setAuthdetails()
    }, [user, isLoaded]);


    useEffect(() => {
        const authSignout = async () => {
            if (loggedOut) {
                omniStorage.removeAll()
                storage.removeItem('token')

                if (window?.Android) {
                    window.Android.clearToken()
                }

                if (window?.Amazon) {
                    window.Amazon.clearToken()
                }

                if (analytics) {
                    setUserProperties(analytics, {has_glasspass: null})
                    setDimension({dimension2: null, dimension1: null})
                }

                webrtc.stop()
                await signOut(() => router.push(`/login${(source === 'app' ? '?source=app' : '')}`))
                dispatch(authenticationLoggedOutFinished())
                setAuthentication(false)
            }
        }

        void authSignout()

    }, [loggedOut])


    return (
        <>
            {isSignedIn && finishedAuthentication && children}
            {!finishedAuthentication && <Loading message={'Loading...'}
                                                 style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0}}/>}
        </>

    )
}
